import { useState } from "react";
import { Box, Button, Card, CardContent, Input, Stack, Typography, IconButton, Textarea } from "@mui/joy";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import SendIcon from "@mui/icons-material/Send";

export default function Comments() {
    const [comment, setComment] = useState("");
    const [comments, setComments] = useState<{ text: string; file?: string }[]>([]);
    const [file, setFile] = useState<File | null>(null);

    const handleCommentSubmit = () => {
        if (!comment.trim() && !file) return;
        setComments([...comments, { text: comment, file: file?.name }]);
        setComment("");
        setFile(null);
    };

    return (
        <Box sx={{ mx: "auto" }}>
            {/* Comment Input Section */}
            <Card variant="soft" sx={{ p: 0, position: "relative" }}>
                <CardContent>
                    <Stack>
                        <Textarea
                            sx={{ background: "transparent" }}
                            placeholder="Add inspection notes..."
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            minRows={4}
                        />
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <Button
                                component="label"
                                variant="plain"
                                startDecorator={<AttachFileIcon />}
                                sx={{ position: "absolute", bottom: 12, right: 120 }}
                                size="sm"
                            >
                                Attach Photo
                                <input
                                    type="file"
                                    accept="image/*"
                                    hidden
                                    onChange={(e) => setFile(e.target.files?.[0] || null)}
                                />
                            </Button>
                            {/* Submit Button */}
                            <Button
                                onClick={handleCommentSubmit}
                                startDecorator={<SendIcon />}
                                variant="soft"
                                size="sm"
                                sx={{ position: "absolute", bottom: 12, right: 12 }}
                            >
                                Submit
                            </Button>
                        </Stack>
                        {/* Show selected file */}
                        {file && (
                            <Typography level="body-sm" sx={{ color: "gray" }}>
                                {file.name}
                            </Typography>
                        )}
                    </Stack>
                </CardContent>
            </Card>

            {/* Comments List */}
            <Box mt={2}>
                {comments.map((c, index) => (
                    <Box key={index} sx={{ mt: 1, p: 1 }}>
                        <Typography level="body-md">{c.text}</Typography>
                        {c.file && (
                            <Typography level="body-sm" sx={{ color: "gray" }}>
                                📎 {c.file}
                            </Typography>
                        )}
                    </Box>
                ))}
            </Box>
        </Box>
    );
}
